<template>
  <div class="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 md:grid-cols-4 lg:grid-cols-6">
    <div
      v-for="month in monthlyWeather"
      :key="month.Month"
      class="group relative rounded-xl px-4 py-4 transition-all duration-200 border border-gray-100"
    >
      <div class="flex items-center justify-between gap-2">
        <span class="text-xs font-semibold tracking-wide text-gray-500">
          {{ formatAsMonthName(month.Month) }}
        </span>

        <span class="text-xs leading-relaxed text-gray-500">
          <TIcon
            :icon="['fal', 'cloud-rain']"
            size="sm"
          />
          {{ month.PrecipMm != null ? `${month.PrecipMm} mm` : '—' }}
        </span>
      </div>

      <div class="mt-3 flex items-baseline gap-1 tabular-nums">
        <span class="text-lg font-semibold tracking-tight">
          {{ formatTemperature(month.AvgHighC, month.AvgHighF) }}
        </span>
        <span class="flex text-xs text-gray-500">
          -
          {{ formatTemperature(month.AvgLowC, month.AvgLowF) }}
        </span>
      </div>

      <p class="mt-2 text-xs leading-relaxed text-gray-500">
        {{ month.Notes }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Park } from '~/types/rental-api-aliases'

const props = defineProps<{
  useCelsius?: boolean
  monthlyWeather?: Park['Weather']
}>()

const { formatAsMonthName } = useDates()

function formatTemperature(temperatureCelsius?: Nullable<number>, temperatureFahrenheit?: Nullable<number>) {
  if (props.useCelsius && typeof temperatureCelsius === 'number') {
    return `${temperatureCelsius}°C`
  }

  return `${temperatureFahrenheit ?? '-'}°F`
}
</script>
